import * as util from '../../globals/methods/util';

export const getClientError = (state) => {
    return state.client.error;
};

export const getClientId = (state) => {
    return state.client.clientJson.clientId;
};

export const getLastName = (state) => {
    return state.client.clientJson.lastName;
};

export const getFirstName = (state) => {
    return state.client.clientJson.firstname;
};

